export default "__VITE_ASSET__NK0BTVD0__"